var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttributes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06991 14.6377L14.6377 8.06991C14.6763 8.0313 14.6763 7.9687 14.6377 7.93009L8.06991 1.36229C8.0313 1.32368 7.9687 1.32368 7.93009 1.36229L1.36229 7.93009C1.32368 7.9687 1.32368 8.0313 1.36229 8.06991L7.93009 14.6377C7.9687 14.6763 8.0313 14.6763 8.06991 14.6377ZM15.5805 9.01272C16.1398 8.45341 16.1398 7.54659 15.5805 6.98728L9.01272 0.419484C8.45341 -0.139828 7.54659 -0.139828 6.98728 0.419483L0.419483 6.98728C-0.139828 7.54659 -0.139828 8.45341 0.419483 9.01272L6.98728 15.5805C7.54659 16.1398 8.45341 16.1398 9.01272 15.5805L15.5805 9.01272Z",
    fill: "#585C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributes);
export default __webpack_public_path__ + "static/media/attributes.8e4089d1.svg";
export { ForwardRef as ReactComponent };